// extracted by mini-css-extract-plugin
export var createdDate = "_mc-1";
export var divider = "_mc-2";
export var headerDivider = "_mc-3";
export var messagesCard = "_mc-0";
export var messagesContainer = "_mc-7";
export var messagesContainerWrapper = "_mc-4";
export var pointerCapturingButtonBoxes = "_mc-a";
export var showLeftPanelButton = "_mc-9";
export var showMoreButton = "_mc-c";
export var showMoreButtonContainer = "_mc-b";
export var summaryTitle = "_mc-6";
export var systemMessageCardWrapper = "_mc-d";
export var topButtons = "_mc-8";
export var withPadding = "_mc-5";